import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { getActiveTraining, clearActiveTraining } from "../lib/activeTraining";

export default function ResumeTrainingButton() {
  const location = useLocation();
  const navigate = useNavigate();
  const [training, setTraining] = useState(null);
  const [, setTick] = useState(0);

  useEffect(() => {
    const check = () => {
      setTraining(getActiveTraining());
      setTick(t => t + 1);
    };
    check();
    const iv = setInterval(check, 1000);
    return () => clearInterval(iv);
  }, [location.pathname]);

  if (!training || location.pathname === training.route) return null;

  const secs = Math.max(0, Math.floor((Date.now() - training.startedAt) / 1000));
  const fmt = `${Math.floor(secs / 60)}:${String(secs % 60).padStart(2, "0")}`;

  return (
    <div className="fixed left-0 right-0 z-[80] flex justify-center px-4 pointer-events-none" style={{ bottom: "84px" }} data-testid="terug-naar-training-container">
      <div className="flex items-center gap-1.5 rounded-full shadow-2xl pl-4 pr-1.5 py-1.5 pointer-events-auto"
        style={{ background: "linear-gradient(135deg, #C9A84C, #D4AF37)", boxShadow: "0 8px 30px rgba(201,168,76,0.35)" }}>
        <button
          data-testid="terug-naar-training-btn"
          onClick={() => navigate(training.route)}
          className="flex items-center gap-2 font-bold text-black text-sm active:scale-95 transition-transform">
          <span className="w-2 h-2 rounded-full bg-black animate-pulse" />
          Terug naar training
          <span className="font-mono text-xs bg-black/15 rounded-full px-2 py-0.5 tabular-nums">{fmt}</span>
        </button>
        <button
          data-testid="training-verwerpen-btn"
          onClick={() => {
            if (window.confirm("Training verwerpen? Je ingevulde sets gaan verloren.")) {
              clearActiveTraining();
              setTraining(null);
            }
          }}
          className="w-7 h-7 rounded-full bg-black/15 flex items-center justify-center text-black active:scale-90 transition-transform">
          <X size={13} />
        </button>
      </div>
    </div>
  );
}
